import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';

import { useIsFocused, useNavigation } from '@react-navigation/native';

import { SizedBox } from '@/components/SizedBox';
import { Box } from '@/components/lib/components';
import { LobbyStackScreenProp } from '@/feature/lobby/screens/Lobby';
import { SearchBar } from '@/feature/search/components/SearchBar';
import { SEARCH_BAR_HEIGHT, SEARCH_BAR_PADDING_TOP } from '@/feature/search/hooks/use-search-dimensions';
import { ROOT_NAVIGATOR_ID } from '@/navigation/container';
import { isWeb } from '@/utils/constants-platform-specific';

export const SEARCH_CONTAINER_HEIGHT = 56;

/**
 * This component displays the SearchBar or an EmptySpace of the size of the SearchBar
 */
export const SearchContainer = ({ display = 'lobby' }: { display?: 'lobby' | 'search' }) => {
    const navigation = useNavigation<LobbyStackScreenProp>();

    const [shouldHideSearchBar, setShouldHideSearchBar] = useState(false);

    useEffect(() => {
        // get parent navigator since the SearchScreen is in the root stack navigator
        return navigation.getParent(ROOT_NAVIGATOR_ID)?.addListener('state', e => {
            const index = e.data.state.index;
            const route = e.data.state.routes[index];
            if (route.name === 'SearchScreen') {
                setShouldHideSearchBar(true);
            } else {
                setShouldHideSearchBar(false);
            }
        });
    }, [navigation]);

    const isFocused = useIsFocused();

    const shouldShow = isWeb ? isFocused : !shouldHideSearchBar;

    return (
        <Box backgroundColor={'gray8'} style={styles.lobbySearchContainer}>
            {shouldShow ? <SearchBar query={'Search'} display={display} /> : <SizedBox value={SEARCH_BAR_HEIGHT} />}
        </Box>
    );
};

const styles = StyleSheet.create({
    lobbySearchContainer: {
        paddingBottom: 4,
        paddingTop: SEARCH_BAR_PADDING_TOP,
        paddingHorizontal: 16,
    },
});
